export default __webpack_public_path__ + "static/media/product-vaccine.520f46be.png";